import { Collapse, CollapseProps } from '@mui/material';
import { FC } from 'react';
import SidebarButton from '../sidebarButton/SidebarButton';

const CollapsiblePanel: FC<React.PropsWithChildren<CollapsiblePanelProps>> = ({
  collapsedSize,
  togglePanel,
  ...props
}) => {
  return (
    <Collapse {...props} orientation='horizontal' collapsedSize={collapsedSize}>
      {props.in ? props.children : <SidebarButton onClick={togglePanel} />}
    </Collapse>
  );
};

export interface CollapsiblePanelProps extends CollapseProps {
  collapsedSize: number;
  togglePanel: () => void;
}

export default CollapsiblePanel;
